import { useTranslation } from 'react-i18next';

import { Field, Form } from 'coreOld/components';
import { InputType, Size } from 'coreOld/enums';
import { uomsService } from 'partsOld/services';
import { ICompanyPart } from 'partsOld/types';

import { uomFormSchema } from './uomFormSchema';

interface IProps {
  onSubmit: (reset?) => (data) => void;
  closeModal: (reset) => void;
  isEditOpen: boolean;
  selectedItem?: Partial<ICompanyPart>;
}

const UomFormView = ({ onSubmit, closeModal, selectedItem, isEditOpen }: IProps) => {
  const { t } = useTranslation();

  return (
    <Form<Partial<ICompanyPart>>
      title={t('labelUpdateCompanyPart')}
      submitBtnLabel={t('buttonLabelUpdateCompanyPart')}
      onClose={closeModal}
      isOpen={isEditOpen}
      onSubmit={onSubmit}
      schema={uomFormSchema}
      selectedItem={selectedItem}
      size={Size.MD}
    >
      <Field
        name="uom"
        type={InputType.ASYNC_SELECT}
        label={t('labelBaseUom')}
        inputProps={{
          getOptions: uomsService.getManyBaseUoms,
          getValue: (opt) => opt?.id,
          getLabel: (opt) => opt?.name,
          requestPayload: {
            filters: {
              is_base: 1,
            },
          },
          placeholder: '',
        }}
      />

      <Field
        name="purchaseCostUom"
        type={InputType.TEXTFIELD}
        label={t('labelPurchaseUom')}
        inputProps={{
          size: Size.LG,
          disabled: true,
        }}
      />

      <Field
        name="salesUom"
        type={InputType.TEXTFIELD}
        label={t('labelSalesUom')}
        inputProps={{
          size: Size.LG,
        }}
      />

      <Field
        name="packageUom"
        type={InputType.TEXTFIELD}
        label={t('labelPackageUom')}
        required={true}
        inputProps={{
          size: Size.LG,
        }}
      />

      <Field
        name="externalUom"
        type={InputType.TEXTFIELD}
        label={t('labelPartExternalUom')}
        inputProps={{
          size: Size.LG,
        }}
      />
    </Form>
  );
};

export default UomFormView;
